import { render, staticRenderFns } from "./DuocSpecialDescriptor.vue?vue&type=template&id=47040768&scoped=true"
import script from "./DuocSpecialDescriptor.vue?vue&type=script&lang=js"
export * from "./DuocSpecialDescriptor.vue?vue&type=script&lang=js"
import style0 from "./DuocSpecialDescriptor.vue?vue&type=style&index=0&id=47040768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47040768",
  null
  
)

export default component.exports